import React from 'react';

import {DocumentTaskReportPage} from 'app/documents/components/DocumentTaskReportPage';
import {
  useProcessByHashid,
  useProcessVersionDetail,
  useProcessVersions,
} from 'app/process/api';

import {ProcessPageSidebar} from './ProcessPageSidebar';

import type {DetailPageBaseProps} from 'app/components/general/DetailPage/types';
import type {ProcessHashidSerializedType} from 'sweet-types';

export const ProcessTaskReportPage = ({
  route,
}: DetailPageBaseProps<ProcessHashidSerializedType>) => (
  <DocumentTaskReportPage
    useData={useProcessByHashid}
    useDataVersion={useProcessVersionDetail}
    useDataVersions={useProcessVersions}
    SideBarComponent={ProcessPageSidebar}
    CurrentLeftSidebar={route.props?.CurrentLeftSidebar}
  />
);
